// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"e1c63291","769":"3aa29838"}[chunkId] + ".chunk.css";
};